/* ============================================================
   Pizza Launch — builder app
   Modes: Men's / Women's / Couples
   Custom dropdown size pickers wired to live Shopify variant data.
   ============================================================ */

/* Mode-driven SET config. Pizza Pants is UNISEX — both genders share
   PIZZA_PANTS_VARIANTS (one product, one shared inventory, like the tee). */
const SET = {
  men: {
    teeImg: ASSET.hero,
    pantsImg: ASSET.menPants,
    pantsMeta: "Men's fit · matching print",
    gift: { name: "Sunday Tee", label: "Sunday Tee", val: 79, img: ASSET.giftMen, variants: SUNDAY_TEE_VARIANTS }
  },
  women: {
    teeImg: ASSET.tee,
    pantsImg: ASSET.womenPants,
    pantsMeta: "Women's fit · matching print",
    gift: { name: "I Don't Do Mornings Tee", label: "I Don't Do Mornings Tee", val: 69, img: ASSET.giftWomen, variants: MORNINGS_TEE_VARIANTS }
  }
};

const SET_PRICE = 188;      // Tee $79 + Pants $109
const COUPLES_PRICE = 376;  // two sets

/* ============================================================
   STATE
   ============================================================ */
const state = {
  mode: 'men',              // 'men' | 'women' | 'couples'
  teeVariantId: null,
  pantsVariantId: null,
  giftVariantId: null,
  c: { mTee: null, mPants: null, mGift: null, wTee: null, wPants: null, wGift: null }
};

/* ============================================================
   PASSWORD GATE
   ============================================================ */
const pins = [...document.querySelectorAll('.pin input')];
pins[0].focus();
pins.forEach((inp, i) => {
  inp.addEventListener('input', () => {
    inp.value = inp.value.replace(/[^0-9]/g, '');
    if (inp.value && i < 3) pins[i+1].focus();
    if (pins.every(p => p.value)) tryUnlock();
  });
  inp.addEventListener('keydown', e => {
    if (e.key === 'Backspace' && !inp.value && i > 0) pins[i-1].focus();
    if (e.key === 'Enter') tryUnlock();
  });
});
document.getElementById('enterBtn').addEventListener('click', tryUnlock);
function tryUnlock() {
  if (pins.map(p => p.value).join('') === '1800') {
    /* iOS: release the focused PIN input BEFORE hiding the gate — hiding a
       focused input while the keyboard is open freezes page scroll on mobile */
    if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
    document.body.classList.add('unlocked');
    setTimeout(() => { document.getElementById('gate').style.display = 'none'; revealInit(); }, 650);
  } else {
    document.getElementById('gateErr').style.opacity = 1;
    document.querySelector('.gate-card').classList.add('shake');
    setTimeout(() => document.querySelector('.gate-card').classList.remove('shake'), 420);
    pins.forEach(p => p.value = ''); pins[0].focus();
  }
}

/* ============================================================
   DROPDOWN size picker — built from live variant data.
   variants: [{ id, size, available }]   onPick(variantId)
   ============================================================ */
function makeDropdown(mount, variants, onPick) {
  if (!mount) return;
  mount.innerHTML = '';
  const dd = document.createElement('div'); dd.className = 'dd';
  const t = document.createElement('button'); t.type = 'button'; t.className = 'dd-t';
  t.innerHTML = '<span class="dd-lab">Size</span><i>▾</i>';
  const p = document.createElement('div'); p.className = 'dd-p';
  variants.forEach(v => {
    const o = document.createElement('button'); o.type = 'button';
    o.className = 'dd-o' + (!v.available ? ' so' : '');
    o.textContent = v.size;
    o.addEventListener('click', e => {
      e.stopPropagation();
      if (!v.available) return;
      [...p.children].forEach(c => c.classList.remove('cur'));
      o.classList.add('cur');
      t.querySelector('.dd-lab').textContent = v.size;
      dd.classList.add('sel'); dd.classList.remove('open');
      onPick(v.id);
    });
    p.appendChild(o);
  });
  t.addEventListener('click', e => {
    e.stopPropagation();
    const open = dd.classList.contains('open');
    document.querySelectorAll('.dd.open').forEach(x => x.classList.remove('open'));
    if (!open) {
      dd.classList.add('open');
      const r = dd.getBoundingClientRect();
      dd.classList.toggle('up', window.innerHeight - r.bottom < 220);
    }
  });
  dd.appendChild(t); dd.appendChild(p); mount.appendChild(dd);
}
document.addEventListener('click', () => document.querySelectorAll('.dd.open').forEach(x => x.classList.remove('open')));

/* ============================================================
   SINGLE-VIEW builders
   ============================================================ */
function buildTee() {
  makeDropdown(
    document.getElementById('teeSizes'),
    PIZZA_TEE_VARIANTS,
    id => { state.teeVariantId = id; sync(); }
  );
}
function buildPants() {
  state.pantsVariantId = null;
  const s = SET[state.mode === 'women' ? 'women' : 'men'];
  makeDropdown(
    document.getElementById('pantsSizes'),
    PIZZA_PANTS_VARIANTS,
    id => { state.pantsVariantId = id; sync(); }
  );
  document.getElementById('pantsMeta').textContent = s.pantsMeta;
}
function buildGift() {
  state.giftVariantId = null;
  const g = SET[state.mode === 'women' ? 'women' : 'men'].gift;
  makeDropdown(
    document.getElementById('giftSizes'),
    g.variants,
    id => { state.giftVariantId = id; sync(); }
  );
  document.getElementById('giftName').textContent = g.label;
  document.getElementById('giftPrice').innerHTML = '<s>$' + g.val + '</s> <em>FREE</em>';
}

/* ============================================================
   COUPLES builder — 6 dropdowns (His tee/pants/gift, Hers tee/pants/gift)
   ============================================================ */
function buildCouples() {
  state.c = { mTee: null, mPants: null, mGift: null, wTee: null, wPants: null, wGift: null };
  makeDropdown(document.getElementById('cmTee'),   PIZZA_TEE_VARIANTS,    id => { state.c.mTee = id; sync(); });
  makeDropdown(document.getElementById('cmPants'), PIZZA_PANTS_VARIANTS,  id => { state.c.mPants = id; sync(); });
  makeDropdown(document.getElementById('cmGift'),  SUNDAY_TEE_VARIANTS,   id => { state.c.mGift = id; sync(); });
  makeDropdown(document.getElementById('cwTee'),   PIZZA_TEE_VARIANTS,    id => { state.c.wTee = id; sync(); });
  makeDropdown(document.getElementById('cwPants'), PIZZA_PANTS_VARIANTS,  id => { state.c.wPants = id; sync(); });
  makeDropdown(document.getElementById('cwGift'),  MORNINGS_TEE_VARIANTS, id => { state.c.wGift = id; sync(); });
}

/* ============================================================
   MODE TABS
   ============================================================ */
function fadeSwap(el, src) {
  if (!el) return;
  el.style.opacity = '0';
  setTimeout(() => { el.src = src; el.style.opacity = '1'; }, 200);
}

function applyMode() {
  document.getElementById('gtab').dataset.active = state.mode;
  document.body.classList.remove('mode-men', 'mode-women', 'mode-couples');
  document.body.classList.add('mode-' + state.mode);
  const couples = state.mode === 'couples';
  document.getElementById('singleView').style.display = couples ? 'none' : 'grid';
  document.getElementById('couplesView').style.display = couples ? 'block' : 'none';
  if (couples) {
    document.getElementById('couplesView').classList.add('in'); // ensure visible (starts as display:none .reveal)
    buildCouples();
  } else {
    const s = SET[state.mode];
    fadeSwap(document.getElementById('imgTee'), s.teeImg);
    fadeSwap(document.getElementById('imgPants'), s.pantsImg);
    fadeSwap(document.getElementById('imgGift'), s.gift.img);
    fadeSwap(document.getElementById('stickyImg'), s.teeImg);
    buildTee();
    buildPants();
    buildGift();
  }
  sync();
}

document.querySelectorAll('#gtab button').forEach(b => {
  b.onclick = () => {
    document.querySelectorAll('#gtab button').forEach(x => x.classList.remove('on'));
    b.classList.add('on');
    state.mode = b.dataset.g;
    applyMode();
  };
});

/* ============================================================
   SYNC — totals + CTA + sticky text
   ============================================================ */
function sync() {
  const btn   = document.getElementById('addBtn');
  const tot   = document.querySelector('.sumcard .tot');
  const free  = document.querySelector('.sumcard .freenote');
  const label = document.querySelector('.sumcard .sk');

  if (state.mode === 'couples') {
    const c = state.c;
    const ready = c.mTee && c.mPants && c.mGift && c.wTee && c.wPants && c.wGift;
    if (label) label.textContent = 'Your two pizza sets';
    if (tot) tot.textContent = '$' + COUPLES_PRICE;
    if (free) {
      free.style.display = 'block';
      free.innerHTML = '+ free Sunday Tee <s>$79</s><br>+ free I Don\'t Do Mornings Tee <s>$69</s>';
    }
    btn.disabled = !ready;
    btn.textContent = ready ? ('Add both sets · $' + COUPLES_PRICE) : 'Select all sizes';
    document.getElementById('stickySel').textContent = ready
      ? ('$' + COUPLES_PRICE + ' · both sets ready')
      : ('$' + COUPLES_PRICE + ' · pick all sizes');
  } else {
    const g = SET[state.mode].gift;
    const ready = state.teeVariantId && state.pantsVariantId && state.giftVariantId;
    if (label) label.textContent = 'Your pizza set';
    if (tot) tot.textContent = '$' + SET_PRICE;
    if (free) {
      free.style.display = '';
      free.innerHTML = '+ free <span id="freeName">' + g.label + '</span> <s id="freeVal">$' + g.val + '</s>';
    }
    btn.disabled = !ready;
    btn.textContent = ready
      ? ('Add to bag · $' + SET_PRICE)
      : (!state.teeVariantId ? 'Select your sizes'
        : (!state.pantsVariantId ? 'Pick your pants size'
          : 'Pick your free tee size'));
    document.getElementById('stickySel').textContent = ready
      ? ('$' + SET_PRICE + ' · sizes selected')
      : ('$' + SET_PRICE + ' · pick your sizes');
  }
}

/* ============================================================
   CART — real Shopify /cart/add.js
   Single set = 3 items (tee + pants + gift).
   Couples    = 6 items (His tee/pants/gift + Hers tee/pants/gift).
   Gift adds at full retail in Phase 1 — the $0 gift is a Phase-2 Shopify discount rule.
   ============================================================ */
let addingToCart = false;

function addToCart() {
  if (state.mode === 'couples') {
    const c = state.c;
    if (!(c.mTee && c.mPants && c.mGift && c.wTee && c.wPants && c.wGift)) {
      scrollTo2('builder'); showToast('Pick all six sizes first'); return;
    }
    postItems([
      { id: c.mTee, quantity: 1 }, { id: c.mPants, quantity: 1 }, { id: c.mGift, quantity: 1 },
      { id: c.wTee, quantity: 1 }, { id: c.wPants, quantity: 1 }, { id: c.wGift, quantity: 1 }
    ]);
    return;
  }
  if (!(state.teeVariantId && state.pantsVariantId && state.giftVariantId)) {
    scrollTo2('builder'); showToast('Pick all your sizes first'); return;
  }
  postItems([
    { id: state.teeVariantId, quantity: 1 },
    { id: state.pantsVariantId, quantity: 1 },
    { id: state.giftVariantId, quantity: 1 }
  ]);
}

function postItems(items) {
  if (addingToCart) return;
  addingToCart = true;
  const btn = document.getElementById('addBtn');
  btn.disabled = true; btn.textContent = 'Adding…';
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items })
  })
  .then(res => res.json())
  .then(data => {
    addingToCart = false;
    btn.disabled = false; sync();
    if (data.status && data.status >= 400) { showToast(data.description || 'Could not add to cart. Please try again.'); return; }
    openStoreCart();
  })
  .catch(() => { addingToCart = false; btn.disabled = false; sync(); showToast('Something went wrong. Please try again.'); });
}

function openStoreCart() {
  if (window.PROJ && window.PROJ.ajaxcart) {
    try { window.PROJ.ajaxcart.updateCart(); window.PROJ.ajaxcart.opencart(); }
    catch (e) { window.location.href = '/cart'; return; }
    setTimeout(updateCartBadge, 700);
  } else {
    window.location.href = '/cart';
  }
}

function updateCartBadge() {
  fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(r => r.json())
    .then(c => {
      var el = document.getElementById('cartCount');
      if (!el) return;
      if (c.item_count > 0) { el.textContent = c.item_count; el.classList.add('show'); }
      else { el.textContent = ''; el.classList.remove('show'); }
    }).catch(function(){});
}

/* ============================================================
   HELPERS
   ============================================================ */
function scrollTo2(id) {
  document.getElementById(id).scrollIntoView({ behavior: 'smooth' });
}

let toastTimer;
function showToast(m) {
  const t = document.getElementById('toast');
  t.textContent = m;
  t.classList.add('show');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => t.classList.remove('show'), 2400);
}

function revealInit() {
  const io = new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
  }), { threshold: .12 });
  document.querySelectorAll('.reveal').forEach(el => io.observe(el));
  document.querySelectorAll('.hero .reveal').forEach((el, i) => {
    el.style.transitionDelay = (i * 0.08) + 's';
    el.classList.add('in');
  });
}

/* ============================================================
   INIT
   ============================================================ */
document.body.classList.add('mode-men');
buildTee();
buildPants();
buildGift();
sync();
document.getElementById('addBtn').onclick = addToCart;

const builderEl = document.getElementById('builder');
window.addEventListener('scroll', () => {
  if (!document.body.classList.contains('unlocked')) return;
  const r = builderEl.getBoundingClientRect();
  document.getElementById('sticky').classList.toggle(
    'show',
    r.top < window.innerHeight * .4 && r.bottom > 0 && window.innerWidth <= 860
  );
});

/* ---- store side-cart wiring ---- */
(function () {
  var cartBtn = document.getElementById('cartBtn');
  if (cartBtn) cartBtn.addEventListener('click', function (e) { e.preventDefault(); openStoreCart(); });
  updateCartBadge();
})();

/* ============================================================
   KLAVIYO SCROLL-LOCK GUARD (2026-06-12 freeze ROOT CAUSE FIX)
   This page force-hides all Klaviyo popups (display:none in the
   section <style>), but Klaviyo still adds the class
   body.klaviyo-prevent-body-scrolling when its (now invisible)
   form opens - body goes overflow:hidden and the page can never
   be scrolled again because the hidden form has no close button.
   Strip the class the moment it appears. CSS backstop lives in
   pizza-launch-cart.css.
   ============================================================ */
(function () {
  function unlock() {
    if (document.body.classList.contains('klaviyo-prevent-body-scrolling')) {
      document.body.classList.remove('klaviyo-prevent-body-scrolling');
    }
  }
  unlock();
  new MutationObserver(unlock).observe(document.body, { attributes: true, attributeFilter: ['class'] });
})();